import React, { useState, useRef } from 'react';
import { Container, Content, Dropdown, Arrow } from './styles';

const SelectMenu = ({ left, value, children, ...props }) => {
  const [open, setOpen] = useState(false);
  const [focusedItem, setFocusedItem] = useState(null);
  const containerRef = useRef(null);
  const dropdownRef = useRef(null);

  const onKeyDownHandler = (e) => {
    // ENTER
    if (e.key === 'Enter') {
      setOpen(!open);
    }
    // ESC
    if (e.key === 'Escape' && open) {
      setOpen(false);
    }
    // DOWN ARROW
    if (e.key === 'ArrowDown' && open) {
      // setOpen(true);
      const items = dropdownRef.current.children;
      let newIndex = 0;

      if (typeof focusedItem !== 'number' || focusedItem === items.length - 1) newIndex = 0;
      else newIndex = focusedItem + 1;

      setFocusedItem(newIndex);
      items[newIndex].focus();
    }
    // UP ARROW
    if (e.key === 'ArrowUp' && open) {
      const items = dropdownRef.current.children;
      let newIndex = 0;

      if (typeof focusedItem !== 'number' || focusedItem === 0) newIndex = items.length - 1;
      else newIndex = focusedItem - 1;

      setFocusedItem(newIndex);
      items[newIndex].focus();
    }
  };

  return (
    <Container
      {...props}
      tabIndex={0}
      onClick={(event) => {
        if (event.target.tagName.toLowerCase() === 'li') {
          setOpen(false);
          return;
        }

        setOpen(true);
      }}
      onKeyDown={onKeyDownHandler}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setOpen(false);
        }
      }}
      open={open}
      ref={containerRef}
      aria-expanded={open}
    >
      {left}
      <Content>{value}</Content>
      <Arrow />
      {open ? (
        <Dropdown ref={dropdownRef} onClick={() => containerRef.current.blur()}>
          {children}
        </Dropdown>
      ) : null}
    </Container>
  );
};

export default SelectMenu;
